const clientStorage = {
  state: {
    viewClientSidebar: false,
    singleClientDeleteClient: null,
    viewClientsSidebarData: null,
    clientclienttoggleData: {
      row_details:null,
      toggle: null
    }
  },
  mutations: {
    SET_CLIENT_DELETE_ID_MUTATION: (state, payload) => {
      state.singleClientDeleteClient = payload
    },
    SET_CLIENT_VIEW_SIDEBAR_MUTATION: (state, payload) => {
      state.viewClientSidebar = payload
    },
    SET_CLIENT_VIEW_SIDEBAR_DATA_MUTATION: (state, payload) => {
      state.viewClientsSidebarData = payload
    },
    SET_CLIENT_TOGGLE_DATA_MUTATION: (state, payload) => {
      state.clientclienttoggleData.row_details = payload.row_details
      state.clientclienttoggleData.toggle = payload.toggle
    }
  },
  actions: {
    SET_CLIENT_DELETE_ID:({commit}, payload) => {
      commit('SET_CLIENT_DELETE_ID_MUTATION', payload)
    },
    SET_VIEW_CLIENT_SIDEBAR: ({commit}, payload) => {
      commit('SET_CLIENT_VIEW_SIDEBAR_MUTATION', payload)
    },
    SET_VIEW_CLIENT_SIDEBAR_DATA: ({commit}, payload) => {
      commit('SET_CLIENT_VIEW_SIDEBAR_DATA_MUTATION', payload)
    },
    SET_CLIENT_TOGGLE_DATA: ({commit}, payload) => {
      commit('SET_CLIENT_TOGGLE_DATA_MUTATION', payload)
    }
  },
  getters: {
    get_client_deleted_id: (state) => {
      return state.singleClientDeleteClient
    },
    get_client_sidebar_view: (state) => {
      return state.viewClientSidebar
    },
    get_client_sidebar_data: (state) => {
      return state.viewClientsSidebarData
    },
    get_client_toggle_data:(state) => {
      return state.clientclienttoggleData
    }
  }
}
export default clientStorage
